import React from 'react';
import { getClusterLabelConfig } from '../../../services/patternClustering.service';

/**
 * ClusterAssignmentCard - Displays cluster assignment for a subject
 */
const ClusterAssignmentCard = ({ assignment, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/3 mb-3"></div>
        <div className="h-8 bg-gray-200 rounded w-2/3 mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
      </div>
    );
  }

  if (!assignment) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Cluster Assignment</h3>
        <div className="text-center py-4 text-gray-500 text-sm">
          <p>No cluster assignment found.</p>
          <p className="text-xs mt-1">Run clustering analysis first.</p>
        </div>
      </div>
    );
  }

  const config = getClusterLabelConfig(assignment.clusterLabel);

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">Cluster Assignment</h3>

      {/* Cluster Badge */}
      <div className="flex items-center gap-3 mb-4">
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-xl"
          style={{ backgroundColor: config.color }}
        >
          {assignment.clusterId}
        </div>
        <div>
          <div className={`px-3 py-1 rounded-full text-sm font-medium ${config.bgColor} ${config.textColor}`}>
            {config.label}
          </div>
          <div className="text-xs text-gray-500 mt-1">{config.description}</div>
        </div>
      </div>

      {/* Quality Scores */}
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="bg-gray-50 p-2 rounded">
          <div className="text-gray-500 text-xs">Distance to Centroid</div>
          <div className="font-semibold">
            {assignment.distanceToCentroid?.toFixed(3) || 'N/A'}
          </div>
          <div className="text-xs text-gray-400">
            {assignment.distanceToCentroid < 0.5 ? 'Strong match' : assignment.distanceToCentroid < 1 ? 'Good match' : 'Weak match'}
          </div>
        </div>
        <div className="bg-gray-50 p-2 rounded">
          <div className="text-gray-500 text-xs">Silhouette Score</div>
          <div className="font-semibold">
            {assignment.silhouetteScore?.toFixed(3) || 'N/A'}
          </div>
          <div className="text-xs text-gray-400">
            {assignment.silhouetteScore > 0.5 ? 'Excellent fit' : assignment.silhouetteScore > 0.25 ? 'Good fit' : assignment.silhouetteScore > 0 ? 'Fair fit' : 'Poor fit'}
          </div>
        </div>
      </div>

      {/* Timestamp */}
      {assignment.assignedAt && (
        <div className="mt-3 text-xs text-gray-400 text-right">
          Assigned: {new Date(assignment.assignedAt).toLocaleString()}
        </div>
      )}
    </div>
  );
};

export default ClusterAssignmentCard;
